/**
 * Customer.io's Startup Program on the marketing site. Shared so the signup
 * funnel and the billing plan grid cannot drift to different program pages.
 */
export const STARTUP_PROGRAM_URL = 'https://customer.io/startup-program/';
export const STARTUP_APPLICATION_URL = 'https://customer.io/startup-program/application/';
